import type { LiveRoom } from "@api-gen/live_pb";

function preferenceScore(room: LiveRoom, preferredRoomIds: Set<string>) {
  let score = 0;
  if (preferredRoomIds.has(room.roomId)) score += 100;
  if (room.tags.some((tag) => tag.includes("官方直播"))) score += 20;
  if (!room.anchorId) score += 10;
  if (room.status === 2) score += 2;
  return score;
}

/**
 * Return at most one user-visible room per match. Match defaults supplied by the
 * sports API always win, followed by explicitly tagged official rooms.
 */
export function officialLiveRooms(
  rooms: LiveRoom[],
  preferredRoomIds: Iterable<string> = [],
) {
  const preferred = new Set(preferredRoomIds);
  const selected = new Map<string, LiveRoom>();

  for (const room of rooms) {
    // Standalone presenter rooms are not part of the official match workflow.
    if (!room.matchId) {
      if (!room.tags.some((tag) => tag.includes("官方直播"))) continue;
      selected.set(`room:${room.roomId}`, room);
      continue;
    }

    const key = `match:${room.matchId}`;
    const current = selected.get(key);
    if (
      !current ||
      preferenceScore(room, preferred) > preferenceScore(current, preferred)
    ) {
      selected.set(key, room);
    }
  }

  return [...selected.values()];
}

export function officialRoomLabel() {
  return "官方直播";
}
